.main-menu .dropdown-header {
  padding-top: 1rem;
  margin-top: 1rem;
}
.main-menu .dropdown-item {
  padding-top: 0.25rem;
  margin-top: 0.25rem;
}
.main-menu .megamenu-hide {
  display: none;
}
